var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "ethers";
import { useCallback, useEffect, useState } from "react";
import { isNativeToken, RibbonTreasuryAddress } from "../constants/constants";
import { AssetsList } from "../store/types";
import { CHAINID, isDevelopment, isProduction } from "../utils/env";
import { getERC20Token } from "./useERC20Token";
import { useETHWeb3Context } from "./web3Context";
export var defaultTreasuryBalanceData = {
    data: Object.fromEntries(AssetsList.map(function (asset) { return [asset, BigNumber.from(0)]; })),
    loading: true,
};
var TreasuryAssets = [
    "WETH",
    // "RBN",
    // "WBTC",
    // "wstETH",
    // "USDC",
    // "AAVE",
];
var useFetchTreasuryBalanceData = function () {
    var _a = useState(defaultTreasuryBalanceData), data = _a[0], setData = _a[1];
    var provider = useETHWeb3Context().provider;
    // const queryChainId = isDevelopment()
    //   ? CHAINID.ETH_KOVAN
    //   : CHAINID.ETH_MAINNET;
    var queryChainId = isDevelopment()
        ? CHAINID.BSC_TEST
        : CHAINID.BSC_MAINNET;
    var doMulticall = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var responses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("Treasury Balance Data Fetch"); // eslint-disable-line
                    }
                    return [4 /*yield*/, Promise.all(TreasuryAssets.map(function (asset) { return __awaiter(void 0, void 0, void 0, function () {
                            var _a, contract, _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        if (!isNativeToken(asset)) return [3 /*break*/, 2];
                                        _a = [asset];
                                        return [4 /*yield*/, provider.getBalance(RibbonTreasuryAddress[queryChainId])];
                                    case 1: return [2 /*return*/, _a.concat([
                                            _c.sent()
                                        ])];
                                    case 2:
                                        contract = getERC20Token(provider, asset.toLowerCase(), queryChainId, false);
                                        _b = [asset];
                                        return [4 /*yield*/, (contract === null || contract === void 0 ? void 0 : contract.balanceOf(RibbonTreasuryAddress[queryChainId]))];
                                    case 3: 
                                    // console.group('useFetchTreasuryBalanceData')
                                    // console.log('asset', asset)
                                    // console.log('contract', contract)
                                    // console.log('RibbonTreasuryAddress[queryChainId]', RibbonTreasuryAddress[queryChainId])
                                    // console.log('queryChainId', queryChainId)
                                    // console.groupEnd()
                                    return [2 /*return*/, _b.concat([
                                            (_c.sent()) ||
                                                BigNumber.from(0)
                                        ])];
                                }
                            });
                        }); }))];
                case 1:
                    responses = _a.sent();
                    setData(function (curr) { return ({
                        data: __assign(__assign({}, curr.data), Object.fromEntries(responses)),
                        loading: false,
                    }); });
                    if (!isProduction()) {
                        console.timeEnd("Treasury Balance Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [queryChainId, provider]);
    useEffect(function () {
        doMulticall();
    }, [doMulticall]);
    return data;
};
export default useFetchTreasuryBalanceData;
//# sourceMappingURL=useFetchTreasuryBalanceData.js.map